<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';
import router from '@/routes/router';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/users`;
const token = utilsService.getToken();

const userService = {
  async getAll() {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async get(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      window.location.href = '/error';
    }
  },

  async getRoles() {
    try {
      const response = await axios.get(`${apiUrl}/roles/options`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async create(formRaw) {
    try {
      const form = { ...formRaw };
      form.empresaID = form.empresaID || 0;
      form.rolID = form.rolID || 0;

      const response = await axios.post(`${apiUrl}/create`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al crear el usuario.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },


  async update(formRaw, id) {
    try {
      const form = { ...formRaw };

      const response = await axios.put(`${apiUrl}/${id}`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      console.error('Error al enviar el formulario', error);
    }
  },

  async updatePass(password, id) {
    try {
      const response = await axios.put(`${apiUrl}/${id}/password`, JSON.stringify(password), {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      console.error('Error al enviar el formulario', error);
    }
  },

  async deleteBy(id) {
    try {
      const response = await axios.delete(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  }
};

export default userService;
</script>
